import {
  useCallback, useContext, useEffect, useState,
} from 'react';
import api from '../../../api/req';
import md from '../../../const/meta';
import { AppContext } from '../../../providers/authProvider';

const usePayerItems = ({ payerId, subUrl }) => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState(null);
  const { auth } = useContext(AppContext);
  const [selectedId, setSelectedId] = useState(null);

  const loader = useCallback(
    async () => {
      const r = await api.get(`${md.cat.payers.backend}${payerId}/${subUrl}/`, auth);
      if (!r.ok) throw new Error(`${r.status} ${r.statusText}`);
      return r.json();
    },
    [auth, payerId, subUrl],
  );
  useEffect(
    () => {
      setLoading(true);
      setErr(null);
      loader()
        .then((d) => setItems(d))
        .catch((e) => setErr(e.message))
        .finally(() => setLoading(false));
    },
    [loader],
  );
  return {
    items,
    loading,
    err,
    selectedId,
    setSelectedId,
  };
};

export default usePayerItems;
